import { useEffect, useState } from 'react';

const POLL_MS = 60e3;

// Keep the last good copy of a section if a refresh fails for it.
const keepGood = (prev, next) =>
  Object.fromEntries(
    Object.entries(next).map(([k, v]) => [k, v?.error && prev?.[k] && !prev[k].error ? prev[k] : v])
  );

// Fetches /api/standings once; polls every minute only on match / race days and only while the tab is visible.
export function useStandings() {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let timer;
    let alive = true;

    const load = async () => {
      clearTimeout(timer);
      try {
        const res = await fetch('/api/standings');
        if (!res.ok) throw new Error(res.status);
        const next = await res.json();
        if (!alive) return;
        setData((prev) => keepGood(prev, next));
        setFailed(false);
        // Clear again: an overlapping load (e.g. from visibilitychange) may have set one meanwhile.
        clearTimeout(timer);
        if (next.live && !document.hidden) timer = setTimeout(load, POLL_MS);
      } catch {
        if (alive) setFailed(true);
      }
    };

    const onVisibility = () => (document.hidden ? clearTimeout(timer) : load());

    load();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      alive = false;
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);

  return { data, failed };
}
